module.exports = __webpack_public_path__ + "img/album20_05.67401e3e.jpg";